<div class="error-page-container">
  <div class="logo-container">
    <img class="logo-image" [ngStyle]="('design' | env).logoStyle" [src]="('design' | env).logo">
    @if (('design' | env).logoText) {
      <div class="logo-text ml-2">{{ ('design' | env).logoText }}</div>
    }
  </div>
  @if (!loading) {
    <div  class="error-page-message mt-5 mb-3 px-3 text-center">{{ 'EXTERNALS.AD_LOGIN.MESSAGE' | translate }}</div>
  }
</div>